import { connect } from 'react-redux';

import { getItemsList } from '../../Items/itemsActions';
import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import { getItemsTransactionsList } from '../itemsTransactionsReportActions';
import ItemsTransactionsReportFilter from './ItemsTransactionsReportFilter';

const ItemsTransactionsReportFilterContainer = ({
  orgMembersList,
  publicZoneList,
  officesShortList,
  selectedOrganization,
  itemsList,
  getPublicZoneList,
  getOfficesShortList,
  getItemsTransactionsList,
  getItemsList,
  getOrganizationMembersList,
  setSelectedParams,
  selectedParams,
}) => {
  return (
    <ItemsTransactionsReportFilter
      orgMembersList={orgMembersList}
      publicZoneList={publicZoneList}
      officesShortList={officesShortList}
      selectedOrganization={selectedOrganization}
      itemsList={itemsList}
      getPublicZoneList={getPublicZoneList}
      getOfficesShortList={getOfficesShortList}
      getItemsTransactionsList={getItemsTransactionsList}
      getItemsList={getItemsList}
      getOrganizationMembersList={getOrganizationMembersList}
      setSelectedParams={setSelectedParams}
      selectedParams={selectedParams}
    />
  );
};

const mapStateToProps = state => ({
  orgMembersList: state.project.orgMembersList,
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  selectedOrganization: state.organization.selectedOrganization,
  itemsList: state.items.itemsList,
});

const mapDispatchToProps = dispatch => ({
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getItemsTransactionsList: params =>
    dispatch(getItemsTransactionsList(params)),
  getItemsList: params => dispatch(getItemsList(params)),
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemsTransactionsReportFilterContainer);
